import Service, { service } from '@ember/service';
import Ember from 'ember';
import { task } from 'ember-concurrency';
import type BlacklistFilter from 'garaje/models/blacklist-filter';
import type CsvAjaxService from 'garaje/services/csv-ajax';
import Papa from 'papaparse';

export default class ExporterService extends Service {
  @service declare csvAjax: CsvAjaxService;

  exportCsv = task(async (filename: string, models: BlacklistFilter[]) => {
    const { document, URL } = window;
    const csvData = models.map((model) => {
      try {
        return model.toDataForCsvExport();
      } catch (error) {
        throw new Error('Model must implement toDataForCsvExport()', <ErrorOptions>error);
      }
    });

    const anchor = document.createElement('a');
    anchor.download = filename;
    anchor.href = URL.createObjectURL(
      new Blob([Papa.unparse(csvData)], {
        type: 'text/csv',
      }),
    );

    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    // eslint-disable-next-line @typescript-eslint/await-thenable
    await null;
  });

  csvFromUrl(url: string, settings: { type: string }, filename: string): void {
    this.csvAjax
      .request(url, settings)
      .then((data) => {
        const url = `data:text/csv;charset=UTF-8,${encodeURIComponent(data)}`;
        const anchor = document.createElement('a');
        anchor.download = filename;
        anchor.href = url;
        anchor.setAttribute('data-test-csv-export-link', 'true');

        if (!Ember.testing) {
          document.body.appendChild(anchor);
          anchor.click();
          anchor.remove();
        } else {
          document.getElementById('ember-testing')?.appendChild(anchor);
        }

        return;
      })
      .catch((error) => {
        throw error;
      });
  }
}
